import { combineReducers } from "redux";
import { userReducer } from "./userReducer";
import { schedulerReducer } from "./schedulerReducer";
import { incomeReducer } from "./incomeReducer";
import { incomeTypeReducer } from "./incomeTypeReducer";
import { expenseReducer } from "./expenseReducer";
import { invoiceReducer } from "./invoiceReducer";
import apiSlice from "../features/api/api.slice.js";
import { paymentReducer } from "./paymentReducer";
import { salaryReducer } from "./salaryReducer";
import { projectReducer } from "./projectReducer";
import { projectBacklogReducer } from "./projectBacklogReducer";
import { projectMilestoneReducer } from "./projectMilestoneReducer";
import { employeeReducer } from "./employeeReducer";
import { leavesReducer } from "./leavesReducer";
import { taskReducer } from "./taskReducer";
import { loanReducer } from "./loanReducer";
import { fundReducer } from "./providentFundReducer";
import { assetReducer } from "./assetsReducer";
import { assetTypeReducer } from "./assetTypeReducer";
import { allocatedAssetsReducer } from "./allocatedAssets";
import { clientReducer } from "./clientReducer";
import { financeReducer } from "./financeReducer";
import { dailyAttendanceReducer } from "./dailyAttendanceReducer";
import { lateComingReducer } from "./lateComingReducer";
import { departmentReducer } from "./departmentsReducer";
import { departmentTaskCategoryReducer } from "./departmentTaskCategoryReducer";
import { userListReducer } from "./userListReducer";
import { teamReducer } from "./teamsReducer";
import { suggestionReducer } from "./suggestionReducer";
import { holidayReducer } from "./holidayReducer";
import { userRoleReducer } from "./userRoleReducer";
import { toDoReducer } from "./toDoreducer";
import { toDoListReducer } from "./toDoListReducer";
import { attendanceReducer } from "./attendanceReducer";
import { feedbackReducer } from "./feedbackReducer";
import { BdProjectDataReducer } from "./BdProjectDataReducer";
import { fileReducer } from "./fileReducer";
import { generalReducer } from "./generalReducer";
import { workloadReducer } from "./workloadReducer";
import { singUpUser } from "./singUpReducer";
import { projectTemplateReducer } from "./projectTemplateReducer";
import { organizationReducer } from "./organizationReducer";
import { manageUserReducer } from "./manageUserReducer";
import { qaProtocolReducer } from "./qaProtocolReducer";
import { stickyNotesReducer } from "./stickyNotesReducer";
import { zoomReducer } from "./zoomReducer";
import { searchFilerBytaskMilestone } from "./searchFilerBytaskMilestone";
import { teamSchedulerReducer } from "./teamSchedulerReducer";
import { reportReducer } from "./reportReducer";

export const rootReducer = combineReducers({
  manageUser: manageUserReducer,
  organization: organizationReducer,
  attendance: attendanceReducer,
  allocatedAssets: allocatedAssetsReducer,
  assets: assetReducer,
  general: generalReducer,
  assetType: assetTypeReducer,
  clients: clientReducer,
  dailyAttendance: dailyAttendanceReducer,
  employee: employeeReducer,
  expenses: expenseReducer,
  file: fileReducer,
  financeDashboard: financeReducer,
  fund: fundReducer,
  income: incomeReducer,
  incomeType: incomeTypeReducer,
  invoices: invoiceReducer,
  lateComing: lateComingReducer,
  leaves: leavesReducer,
  loans: loanReducer,
  payment: paymentReducer,
  project: projectReducer,
  projectBacklog: projectBacklogReducer,
  projectMilestone: projectMilestoneReducer,
  salary: salaryReducer,
  scheduler: schedulerReducer,
  task: taskReducer,
  user: userReducer,
  departments: departmentReducer,
  departmentTaskCategories: departmentTaskCategoryReducer,
  userList: userListReducer,
  teams: teamReducer,
  suggestion: suggestionReducer,
  holidays: holidayReducer,
  userRoles: userRoleReducer,
  todos: toDoReducer,
  todoList: toDoListReducer,
  feedback: feedbackReducer,
  bdProjectData: BdProjectDataReducer,
  workloadReducer: workloadReducer,
  singUpUser: singUpUser,
  projectTemplate: projectTemplateReducer,

  qaProtocol: qaProtocolReducer,
  stickyNotes: stickyNotesReducer,
  zoom: zoomReducer,
  teamScheduler: teamSchedulerReducer,
  report: reportReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  // searchFilerBytaskMilestone: searchFilerBytaskMilestone,
});
